var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CallSupport } from '@/components/call-support.component';
import { Typography } from '@mui/material';
import { useAnalytics } from 'hx-analytics';
export function Troubleshooting() {
    var sendButtonClick = useAnalytics().sendButtonClick;
    return (_jsxs("div", __assign({ className: "flex flex-col gap-8 text-center" }, { children: [_jsx(Typography, __assign({ variant: "h2" }, { children: "Troubleshooting" })), _jsxs("div", __assign({ className: "flex flex-col gap-4 text-center" }, { children: [_jsxs(Typography, { children: [_jsx("strong", { children: "Headphones: " }), "Ensure your headphones or earphones are plugged in or connected via Bluetooth", _jsx("sup", { children: "\u00AE" }), "."] }), _jsxs(Typography, { children: [_jsx("strong", { children: "Device: " }), "Check that your device's sound is not muted."] }), _jsxs(Typography, { children: [_jsx("strong", { children: "Browser: " }), "This test works best with browsers like Chrome, Safari, Firefox, or the latest version of Edge."] })] })), _jsxs("div", __assign({ className: "flex flex-col gap-2 items-center" }, { children: [_jsx(Typography, { children: "Need help?" }), _jsx(CallSupport, { onClick: function () {
                            sendButtonClick('volume_call_lexie');
                        } })] }))] })));
}
